export const isValidUrl = (url: string): boolean => {
  try {
    if (!url || !url.trim()) {
      return false;
    }
    const urlObj = new URL(url);
    if (!['http:', 'https:'].includes(urlObj.protocol) || !urlObj.hostname) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
};
